'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateSubtotal = exports.toDollars = exports.removeLineItem = exports.updateQuantityByIncrement = exports.updateQuantityByText = exports.updateLineItem = exports.addCartItem = exports.setCartState = exports.updateCart = exports.hideCart = exports.showCart = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _handlers = require('scripts/components/Overlay/handlers');

var _handlers2 = require('scripts/components/Scroll/handlers');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var options = void 0;
var selectedVariantID = void 0;
var variantId = void 0;
var cartCount = void 0;

var OUT_OF_STOCK_MESSAGE = 'Sorry, that product is out of stock!';
var OVER_LIMIT_MESSAGE = 'Sorry, you have reached the maximum quantity of this product.';

var _error2 = function error(_error, message) {
  console.error('Error ' + _error);

  if (message && message.length > 0) {
    alert(message);
  }
};

var _success = function _success(data, textStatus, jqXHR) {
  updateCart();

  if (!$(_Dom2.default.inlineCart).hasClass('is-active')) {
    showCart();
  }
};

var showCart = exports.showCart = function showCart() {
  $(_Dom2.default.inlineCart).addClass('is-active');
  (0, _handlers.showOverlay)();
  (0, _handlers2.scrollLock)();
};

var hideCart = exports.hideCart = function hideCart() {
  $(_Dom2.default.inlineCart).removeClass('is-active');
  (0, _handlers.hideOverlay)();
  (0, _handlers2.scrollUnlock)();
};

var updateCart = exports.updateCart = function updateCart(callback) {
  $.get('/cart?view=contents', function (response) {
    $(_Dom2.default.lineItemEntryPoint).html(response);
    if (typeof callback === 'function') {
      callback();
    }
  });
};

var setCartState = exports.setCartState = function setCartState() {
  cartCount = CartJS.cart.item_count;

  if (cartCount === 0) {
    $(_Dom2.default.cartFull).hide();
    $(_Dom2.default.cartEmpty).show();
    $(_Dom2.default.cartIconEmpty).removeClass('u-visually-hidden');
    $(_Dom2.default.cartIconFull).addClass('u-visually-hidden');
  } else {
    $(_Dom2.default.cartFull).show();
    $(_Dom2.default.cartEmpty).hide();
    $(_Dom2.default.cartIconEmpty).addClass('u-visually-hidden');
    $(_Dom2.default.cartIconFull).removeClass('u-visually-hidden');
  }
};

var addCartItem = exports.addCartItem = function addCartItem(variantId, quantity) {
  window.CartJS.addItem(variantId, quantity, {}, {
    success: _success,
    error: function error(jqXHR, textStatus, errorThrown) {
      return _error2(errorThrown, OUT_OF_STOCK_MESSAGE);
    }
  });
};

var updateLineItem = exports.updateLineItem = function updateLineItem(varaintId, quantity) {
  window.CartJS.updateItemById(variantId, quantity, {}, {
    success: _success,
    error: function error(jqXHR, textStatus, errorThrown) {
      return _error2(errorThrown);
    }
  });
};

var checkQuantityLimit = function checkQuantityLimit(quantityLimit, productType, newQuantity) {
  if (isNaN(quantityLimit)) {
    if (productType === 'medical-thermometers' && newQuantity > 2) {
      alert(OVER_LIMIT_MESSAGE);
      return false;
    }
  } else {
    if (newQuantity > quantityLimit) {
      alert(OVER_LIMIT_MESSAGE);
      return false;
    }
  }
  return true;
};

var updateQuantityByText = exports.updateQuantityByText = function updateQuantityByText($this) {
  var variantId = parseInt($this.closest('[data-line-item]').attr('data-variant-id'), 10);
  var quantityLimit = parseInt($this.closest('[data-line-item]').attr('data-quantity-limit'), 10);
  var productType = $this.closest('[data-line-item]').attr('data-product-type');

  var newQuantity = parseInt($this.val());

  if (checkQuantityLimit(quantityLimit, productType, newQuantity)) {
    window.CartJS.updateItemById(variantId, newQuantity, {}, {
      success: _success,
      error: function error(jqXHR, textStatus, errorThrown) {
        return _error2(errorThrown);
      }
    });
  }
};

var updateQuantityByIncrement = exports.updateQuantityByIncrement = function updateQuantityByIncrement($this) {
  var direction = $this.attr('data-quantity-change');
  var variantId = parseInt($this.closest('[data-line-item]').attr('data-variant-id'), 10);
  var currentQuantity = parseInt($this.siblings('[data-quantity-number]').val());
  var quantityLimit = parseInt($this.closest('[data-line-item]').attr('data-quantity-limit'), 10);
  var newQuantity = direction === 'up' ? currentQuantity + 1 : currentQuantity - 1;
  var productType = $this.closest('[data-line-item]').attr('data-product-type');

  if (direction === 'up') {

    if (checkQuantityLimit(quantityLimit, productType, newQuantity)) {
      window.CartJS.updateItemById(variantId, newQuantity, {}, {
        success: function success(response) {
          var item = response.items.find(function (item) {
            return item.id === variantId;
          });

          if (item.quantity < newQuantity) {
            alert(OUT_OF_STOCK_MESSAGE);
          } else {
            _success();
          }
        },
        error: function error(jqXHR, textStatus, errorThrown) {
          return _error2(errorThrown, OUT_OF_STOCK_MESSAGE);
        }
      });
    }
  } else {
    if (currentQuantity === 1) {
      removeLineItem(variantId);
    } else {
      window.CartJS.updateItemById(variantId, newQuantity, {}, {
        success: _success,
        error: function error(jqXHR, textStatus, errorThrown) {
          return _error2(errorThrown);
        }
      });
    }
  }
};

var removeLineItem = exports.removeLineItem = function removeLineItem(variantId) {
  window.CartJS.removeItemById(variantId, {
    success: _success,
    error: function error(jqXHR, textStatus, errorThrown) {
      return _error2(errorThrown);
    }
  });
};

var toDollars = exports.toDollars = function toDollars(cents) {
  return (cents / 100.0).toFixed(2);
};

var updateSubtotal = exports.updateSubtotal = function updateSubtotal() {
  var subtotal = toDollars(window.CartJS.cart.total_price);
  $(_Dom2.default.cartSubtotal).text(subtotal).prepend('$');
};